exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Bars__whiteAxis-Af {\n  flex: 0 0 auto;\n  color: white\n}\n.Bars__whiteAxis-Af .tick text {\n      fill: white;\n    }\n.Bars__whiteAxis-Af .tick line {\n      stroke: white;\n    }\n.Bars__whiteAxis-Af .domain {\n    stroke: white;\n  }\n", ""]);

// exports
exports.locals = {
	"whiteAxis": "Bars__whiteAxis-Af"
};